import { render, staticRenderFns } from "./StudentInformationDetails.vue?vue&type=template&id=2c3df535&scoped=true&"
import script from "./StudentInformationDetails.vue?vue&type=script&lang=js&"
export * from "./StudentInformationDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3df535",
  null
  
)

export default component.exports